import { configureStore } from '@reduxjs/toolkit';
import vehicleReducer from './reducers/vehicleReducer';
import priceReducer from './reducers/priceReducer';
import benefitReducer from './reducers/benefitReducer';
import profileReducer from './reducers/profileReducer';
import flowStepReducer from './reducers/flowStepReducer';
import cityStateReducer from './reducers/cityStateReducer';
import alertReducer from './reducers/alertReducer';
import otpReducer from './reducers/otpReducer';
import myPlansReducer from './reducers/myPlansReducer';
import claimReducer from './reducers/claimReducer';
import paymentsReducer from './reducers/paymentsReducer';

const store = configureStore({
  reducer: {
    vehicleList: vehicleReducer,
    priceList:   priceReducer,
    benefitList: benefitReducer,
    profileList: profileReducer,
    flowStepList: flowStepReducer,
    cityStateList: cityStateReducer,
    alertList: alertReducer,
    OtpAuthenticateList:otpReducer,
    myPlanList:myPlansReducer,
    claimList:claimReducer,
    paymentsList:paymentsReducer
  },
});
export default store;
